import { render, staticRenderFns } from "./SetLaborBurden.vue?vue&type=template&id=c2c75588"
import script from "./SetLaborBurden.vue?vue&type=script&lang=js"
export * from "./SetLaborBurden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports